import { AddressRequestT, RegistrationAddressT } from '../../types';

export const serializeAddress = (address: RegistrationAddressT): AddressRequestT => {
  return {
    apt_or_unit: address.addressLine2,
    city: address.city,
    home_address: address.addressLine1,
    postal_code: address.postalCode,
    state: address.state,
  };
};
